/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import { albumAuthorModelSchema } from "./albumAuthorModelSchema.ts";
import { albumTypeEnumSchema } from "./albumTypeEnumSchema.ts";
import { fileModelSchema } from "./fileModelSchema.ts";
import { z } from "zod";

export const albumModelSchema = z.object({
    "id": z.string().uuid().describe("Идентификатор"),
"name": z.string().describe("Название"),
"picture": z.lazy(() => fileModelSchema).describe("Обложка").nullable().nullish(),
"type": z.lazy(() => albumTypeEnumSchema).describe("<p>Возможные значения:</p>\n<ul>\n<li><b>1 - Music</b>: Музыкальный альбом</li>\n<li><b>2 - Podcast</b>: Альбом подкастов</li>\n<li><b>3 - Book</b>: Альбом книг</li>\n<li><b>4 - Sermon</b>: Альбом проповедей</li>\n</ul>\n"),
"releaseDate": z.string().date().describe("Дата выпуска").nullable().nullish(),
"excludeSearch": z.boolean().describe("Исключить из поиска"),
"authors": z.array(z.lazy(() => albumAuthorModelSchema)).describe("Авторы")
    })